import {
  addDoc,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  doc,
} from "firebase/firestore";
import { getFirebaseWebFirestore } from "./firebaseWeb";

const PRESENCE_COLLECTION = "webUserPresence";
const PRESENCE_DIAGNOSTIC_COLLECTION = "webPresenceDiagnosticLogs";

function toMillis(value) {
  if (!value) return 0;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (value instanceof Date) return value.getTime();
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

function sanitizePresenceError(error) {
  return {
    code: String(error?.code || "presence/unknown"),
    message: String(error?.message || "Presence error").slice(0, 500),
    name: String(error?.name || "Error"),
  };
}

export async function reportPresenceDiagnostic({ operation, uid, error, severity = "error" }) {
  const payload = {
    operation,
    severity,
    uid: uid || null,
    error: sanitizePresenceError(error),
    createdAt: serverTimestamp(),
  };

  console.warn(`[DenkUP presence] ${operation}`, payload.error);

  try {
    const db = getFirebaseWebFirestore();
    await addDoc(collection(db, PRESENCE_DIAGNOSTIC_COLLECTION), payload);
  } catch (logError) {
    console.warn("Presence diagnostic log yazılamadı.", sanitizePresenceError(logError));
  }
}

export async function presencePing({ uid, displayName }) {
  if (!uid) return;
  const db = getFirebaseWebFirestore();

  const ref = doc(db, PRESENCE_COLLECTION, uid);
  await setDoc(ref, {
    uid,
    displayName: displayName || null,
    online: true,
    lastSeenAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}

export async function presenceOffline({ uid }) {
  if (!uid) return;
  const db = getFirebaseWebFirestore();

  const ref = doc(db, PRESENCE_COLLECTION, uid);
  await setDoc(ref, {
    online: false,
    lastSeenAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}

export async function listActiveUserCount({ windowMinutes = 5, max = 300 } = {}) {
  const db = getFirebaseWebFirestore();

  const snapshot = await getDocs(query(
    collection(db, PRESENCE_COLLECTION),
    orderBy("lastSeenAt", "desc"),
    limit(Math.max(10, Math.min(max, 500))),
  ));

  const now = Date.now();
  const threshold = Math.max(1, windowMinutes) * 60 * 1000;
  let count = 0;

  snapshot.docs.forEach((entry) => {
    const data = entry.data() || {};
    const lastSeenMs = toMillis(data.lastSeenAt);
    if (lastSeenMs > 0 && now - lastSeenMs <= threshold) count += 1;
  });

  return count;
}
